import React from 'react';
import PropTypes from 'prop-types';
import { Button, SelectPicker } from 'rsuite';
import { SORT_OPTIONS } from './deckSortingUtils';
import { VIEW_MODES, VIEW_MODE_DISPLAY } from '../../helpers/viewModeConstants';

const DeckViewControls = ({
  tableData,
  viewMode,
  onViewModeChange,
  cardLoading,
  deckPrefs,
  onGroupByChange,
  sortColumn,
  allColumns,
  COLORS,
}) => {
  if (tableData.length === 0) return null;

  return (
    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center', marginBottom: 16 }}>
      <div style={{ display: 'flex', gap: 4 }}>
        <Button
          title={VIEW_MODE_DISPLAY[VIEW_MODES.TABLE].label}
          appearance={viewMode === VIEW_MODES.TABLE ? 'primary' : 'default'}
          onClick={() => onViewModeChange(VIEW_MODES.TABLE)}
          size="xs"
          style={{ fontSize: 16, padding: '6px 10px', minWidth: 32, minHeight: 32 }}
        >
          {VIEW_MODE_DISPLAY[VIEW_MODES.TABLE].icon}
        </Button>
        <Button
          title={VIEW_MODE_DISPLAY[VIEW_MODES.VISUAL].label}
          appearance={viewMode === VIEW_MODES.VISUAL ? 'primary' : 'default'}
          onClick={() => onViewModeChange(VIEW_MODES.VISUAL)}
          disabled={cardLoading}
          size="xs"
          style={{ fontSize: 16, padding: '6px 10px', minWidth: 32, minHeight: 32 }}
        >
          {VIEW_MODE_DISPLAY[VIEW_MODES.VISUAL].icon}
        </Button>
      </div>
      {viewMode === VIEW_MODES.VISUAL && (
        <SelectPicker
          data={SORT_OPTIONS}
          value={deckPrefs.sortBy}
          onChange={onGroupByChange}
          style={{ width: 140 }}
          size="xs"
          placeholder="Group by..."
        />
      )}
      {viewMode === VIEW_MODES.TABLE && sortColumn && (
        <span style={{ fontSize: 12, color: COLORS.muted, backgroundColor: COLORS.darkBg, padding: '4px 8px', borderRadius: 4 }}>
          Sorted by: <strong>{allColumns.find(c => (c.sortKey || c.key) === sortColumn)?.label || sortColumn}</strong>
        </span>
      )}
    </div>
  );
};

DeckViewControls.propTypes = {
  tableData: PropTypes.array.isRequired,
  viewMode: PropTypes.oneOf([VIEW_MODES.TABLE, VIEW_MODES.VISUAL]).isRequired,
  onViewModeChange: PropTypes.func.isRequired,
  cardLoading: PropTypes.bool,
  deckPrefs: PropTypes.object.isRequired,
  onGroupByChange: PropTypes.func.isRequired,
  sortColumn: PropTypes.string,
  allColumns: PropTypes.array.isRequired,
  COLORS: PropTypes.object.isRequired,
};

DeckViewControls.defaultProps = {
  cardLoading: false,
  sortColumn: null,
};

export default DeckViewControls;
